import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import '../../../Typography/index.js';
import './components/LabelSuffix/index.js';
import { useLabel } from './hooks/useLabel.js';
import { Typography } from '../../../Typography/Typography.js';
import { LabelSuffix } from './components/LabelSuffix/LabelSuffix.js';

var _excluded = ["suffixIndicator"];
var LabelComponent = function LabelComponent(_ref) {
  var suffixIndicator = _ref.suffixIndicator,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useLabel = useLabel(props),
    labelProps = _useLabel.labelProps,
    labelContainerProps = _useLabel.labelContainerProps;
  return /*#__PURE__*/React.createElement("div", labelContainerProps, /*#__PURE__*/React.createElement(Typography, labelProps, props.text), /*#__PURE__*/React.createElement(LabelSuffix, {
    suffixIndicator: suffixIndicator
  }));
};
LabelComponent.displayName = 'Label';
var Label = /*#__PURE__*/React.memo(LabelComponent);

export { Label, LabelComponent };
//# sourceMappingURL=Label.js.map
